import intl from "react-intl-universal";
export function secondHandFormType() {
    return (
        [
            {
                baseComponent: intl.get("JICHUXINXI"),
                show: true,
                id: 1,
                data: [
                    {
                        type: "specialSelect",
                        name: "childCategory",
                        require: false,
                        requireMsg: 'please select',
                        label: intl.get("XINGZXHI"),
                        typeData: [],
                    },
                    {
                        type: "input",
                        name: "productName",
                        require: true,
                        requireMsg: 'please input',
                        label: intl.get("SHANGPING"),
                    },
                    {
                        type: "radio",
                        name: "sellerType",
                        require: true,
                        requireMsg: 'please select',
                        label: intl.get("FATIELEIXING"),
                        typeData: [
                            {
                                label: intl.get("GEREN"),
                                value: 1,
                            },
                            {
                                label: intl.get("SHANGJIA"),
                                value: 2,
                            },
                        ],
                    },
                    {
                        type: "radio",
                        name: "dealType",
                        require: true,
                        requireMsg: 'please select',
                        label: intl.get("JIAOYILEIXING"),
                        typeData: [
                            {
                                label: intl.get("CHUSHOU"),
                                value: 1,
                            },
                            {
                                label: intl.get("QIUGOU"),
                                value: 2,
                            },
                            {
                                label: intl.get("ZENGSONG"),
                                value: 3,
                            },
                        ],
                    },
                    {
                        type: "select",
                        name: "productType",
                        require: true,
                        requireMsg: 'please select',
                        mutial: true,
                        label: intl.get("SHANGPIINGFENLEI"),
                        typeData: [
                            {
                                label: intl.get("ERSHOUQICHE"),
                                value: 1,
                            },
                            {
                                label: intl.get("JIAJUYONGPING"),
                                value: 2,
                            },
                            {
                                label: intl.get("DIANQIDIANNAO"),
                                value: 3,
                            },
                            {
                                label: intl.get("SHOUJIPEIJAN"),
                                value: 4,
                            },
                            {
                                label: intl.get("FUZHUANGSHIPING"),
                                value: 5,
                            },
                            {
                                label: intl.get("MEIRONGHUFU"),
                                value: 6,
                            },
                            {
                                label: intl.get("SHIPINGYINLIAO"),
                                value: 7,
                            },
                            {
                                label: intl.get("MUYINCANGPING"),
                                value: 8,
                            },
                            {
                                label: intl.get("QITA"),
                                value: 9,
                            },
                        ],
                    },
                    {
                        type: "radio",
                        name: "newOrOld",
                        require: true,
                        requireMsg: 'please select',
                        label: intl.get("XINJIUCHENGDU"),
                        typeData: [
                            {
                                label: intl.get("QUANXIAN"),
                                value: 1,
                            },
                            {
                                label: intl.get("ERSHOU"),
                                value: 2,
                            },
                            {
                                label: intl.get("BUXIAN"),
                                value: 3,
                            },
                        ],
                    },
                    {
                        type: "select",
                        name: "regionId",
                        mutial: true,
                        require: true,
                        requireMsg: 'please select',
                        label: intl.get("SUOZAIQUYU"),
                        typeData: [
                            {
                                label: intl.get("BULISB"),
                                value: 1,
                            },
                            {
                                label: intl.get("HUANGJIANHAN"),
                                value: 2,
                            },
                            {
                                label: intl.get("YANGHUANGHANHAN"),
                                value: 3,
                            },
                            {
                                label: intl.get("KAIENSI"),
                                value: 4,
                            }
                        ]
                    },
                    {
                        type: "input",
                        name: "price",
                        require: true,
                        requireMsg: 'please input',
                        label: intl.get("JIAGE"),
                    },
                    {
                        type: "radio",
                        name: "sendType",
                        label: intl.get("SONGHUOFANGSI"),
                        typeData: [
                            {
                                label: intl.get("MIANYOUJIJIJIAN"),
                                value: 1,
                            },
                            {
                                label: intl.get("SHANGMENLINGQU"),
                                value: 2,
                            },
                            {
                                label: intl.get("SONGHUO"),
                                value: 3,
                            },
                        ],
                    },
                ]
            },
            {
                baseComponent: intl.get("XIANGQINGMIAOSHU"),
                show: true,
                id: 2,
                data: [
                    {
                        type: "edit",
                        name: "context",
                        require: true,
                        label: intl.get("XIANGQINGMIAOSHU"),
                    }
                ]
            },
            {
                baseComponent: intl.get("SHANGCHUANGTUPIAN"),
                show: true,
                id: 3,
                data: [
                    {
                        type: "upload",
                        name: "path",
                        require: false,
                        label: intl.get("SHANGCHUANGTUPIAN"),
                    }
                ]
            },
            {
                baseComponent: intl.get("LIANXIFANGSHI"),
                show: true,
                id: 4,
                data: [
                    {
                        type: "input",
                        name: "phone",
                        require: true,
                        requireMsg: 'please input',
                        label: intl.get("LIANXIDIANHUA"),
                    },
                    {
                        type: "input",
                        name: "email",
                        require: false,
                        label: intl.get("DIANZIYOUJIAN"),
                    },
                    {
                        type: "input",
                        name: "wechat",
                        require: false,
                        label: intl.get("WEIXIN"),
                    },
                    {
                        type: "input",
                        name: "line",
                        require: false,
                        label: intl.get("LINE"),
                    },
                    {
                        type: "input",
                        name: "facebook",
                        require: false,
                        label: intl.get("Facebook"),
                    },
                    {
                        type: "input",
                        name: "qq",
                        require: false,
                        label: intl.get("QQ"),
                    },
                ]
            }
        ]
    )
}